module.exports = __webpack_public_path__ + "static/img/equalyz.e548c8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/equalyz.png
// module id = UW3H
// module chunks = 0